import { v4 as uuidv4 } from "uuid";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { FormattedRpServiceConfigurationPolicyConfigDecision, RpServiceConfigurationPolicyConfigDecision } from "@idw-types/data/rp-service-configuration";
import { DeployedPolicyComponent } from "@idw-types/data/reference-data/generic";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { formatRpServiceConfigurationPolicyConfigDecisionConditions } from "./rp-service-configuration-policy-config-decision-condition-formatter";

export const formatRpServiceConfigurationPolicyConfigDecisions = (
    decisions: Array<RpServiceConfigurationPolicyConfigDecision>,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): Array<FormattedRpServiceConfigurationPolicyConfigDecision> => {
    return decisions.map(decision => formatRpServiceConfigurationPolicyConfigDecision(decision, deployedPolicyComponents, axnAttributeTypeFields));
};

export const formatRpServiceConfigurationPolicyConfigDecision = (
    decision: RpServiceConfigurationPolicyConfigDecision,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): FormattedRpServiceConfigurationPolicyConfigDecision => {
    const conditions = formatRpServiceConfigurationPolicyConfigDecisionConditions(
        decision.conditions || [],
        deployedPolicyComponents,
        axnAttributeTypeFields
    );

    return {
        conditions: conditions,
        description: decision.description,
        disposition: decision.disposition,
        id: decision.id,
        obligationValue: decision.obligationValue,
        policyDecisionOperationType: decision.policyDecisionOperationType,
        policyDecisionType: decision.policyDecisionType,
        retries: decision.retries,
        status: decision.status || EntityStatusTypes.INACTIVE,
        uuid: uuidv4()
    };
};